import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {ScrollToService} from "ng2-scroll-to-el";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {TranslateService} from '@ngx-translate/core';
import {animate, state, style, transition, trigger} from "@angular/animations";
import {DefaultSmartRequest, SmartSelectService} from "../services/smartselect.service";
import {StateService} from "../services/state.service";
import {SEOService} from "../services/seo.service";


@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: [
        './about.component.less',
        '../tools/header.less'
    ],
    animations: [
        trigger("HeaderH1", [
            state('init', style({
                opacity: '0',
                position: 'relative',
                left: '3em',
            })),
            state('show', style({
                opacity: '1',
                position: 'relative',
                left: '0em',
            })),
            transition('init => show', [
                animate('1s ease-out')
            ]),

        ]),

        trigger("HeaderP", [
            state('init', style({
                opacity: '0',
                position: 'relative',
                left: '10em',
            })),
            state('show', style({
                opacity: '1',
                position: 'relative',
                left: '0em',
            })),
            transition('init => show', [
                animate('3s ease')
            ]),

        ]),

    ]
})


export class AboutComponent implements OnInit {

    constructor(
        private readonly translate: TranslateService,
        private scrollService: ScrollToService,
        public router: Router,
        public activatedRoute: ActivatedRoute,
        public smartService: SmartSelectService,
        public state: StateService,
        private SEOService: SEOService
    ) {

        this.smartModel = DefaultSmartRequest;
        this.smartService.setModel(this.smartModel);
        setInterval(() => this.showHeader(), 200);
        window.scroll(0, 0);
        this.minimenu = window.innerWidth > this.maxWidthMenu;

        this.textList = [true, false, false];

    }

    ngAfterViewInit() {
        // TODO: fix video box for thin devices
        // нужна проверка высоты объекта и видео;
    }

    ngOnInit(): void {
        // set meta tags
        const { meta } = this.activatedRoute.snapshot.data;
        this.SEOService.updateTitle(meta.title);
        this.SEOService.updateDescription(meta.description);
        // this.SEOService.updateKeywords(meta.keywords);

        this.dockShowSubscription = this.state.getDockShowChangeEmitter()
            .subscribe(dockShow => {
                this.dockShow = (dockShow == 'dock-show');
            })
    }

    ngOnDestroy() {
        if (this.smartTimer) clearTimeout(this.smartTimer);
        this.dockShowSubscription.unsubscribe();
    }

    @ViewChild('smartBox1') smartBox1: ElementRef;
    @ViewChild('smartBox2') smartBox2: ElementRef;

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.fixSmartSize();
        this.minimenu = window.innerWidth > this.maxWidthMenu;
    }

    public HeaderState = 'init';

    public dockShowSubscription: any;
    public dockShow = false;

    public showHeader() {
        this.HeaderState = 'show'
    }

    public minimenu = true;

    public onClickMiniMenuBtn(evt) {
        this.minimenu = !this.minimenu;
        evt.stopPropagation();
        return false;
    }

    maxWidthMenu = 992;

    scrollToEl(element, offset?) {
        this.scrollService.scrollTo(element, 800, offset || -100);
        if (window.innerWidth < this.maxWidthMenu) {
            this.minimenu = false;
        }
    }

    public boxHeight = ['', '', '', ''];


    public counter1: number;
    public counter2: number;
    public counter3: number;
    public counter4: number;
    public counter5: number;
    public counter6: number;


    public showContactForm = false;

    onShowContactForm() {
        this.showContactForm = true;
        this.freezeWindow();
    }

    onCloseContactForm(val) {
        this.showContactForm = false;
        this.unFreezeWindow();
    }


    public smartDetials = false;
    public showSmartForm = false;

    onShowSmartForm() {
        this.showSmartForm = true;
        this.freezeWindow();
    }

    onCloseSmartForm(val) {
        this.showSmartForm = false;
        this.smartDetials = false;
        this.smartService.getModel();
        this.unFreezeWindow();

    }


    public pageState = <any>{
        position: 'inherit',
        top: 0
    };

    freezeWindow() {
        this.pageState.position = 'fixed';
        this.pageState.top = window.scrollY;
    }

    unFreezeWindow() {
        this.pageState.position = 'inherit';
        window.setTimeout(this.scrollWindow.bind(this), 50);
    }


    scrollWindow() {
        window.scroll(0, this.pageState.top);
    }


    onShowDetails(val?) {
        this.smartDetials = val || !this.smartDetials;
        // this.timer = window.setTimeout(this.changeTime.bind(this), 1000);
        if (this.smartTimer) clearTimeout(this.smartTimer);
        this.smartTimer = window.setTimeout(this.fixSmartSize.bind(this), 500);
    }

    public smartTimer;
    public smartModel: any;

    onChangeSmartModel(item) {
        eval('this.smartModel.' + item + '=!this.smartModel.' + item);
        this.smartService.setModel(this.smartModel);
    }

    public smartHeight1 = '';
    public smartHeight2 = '';

    fixSmartSize() {
        if (!this.smartDetials) {
            this.smartHeight2 = '';
            this.smartHeight1 = '';
            return;
        }
        if (window.innerWidth > 1200) {
            this.smartHeight2 = this.smartBox2.nativeElement.offsetHeight + 'px';
            this.smartHeight1 = this.smartHeight2;
        } else if (window.innerWidth >= 768) {
            this.smartHeight1 = this.smartBox1.nativeElement.offsetHeight + 'px';
            this.smartHeight2 = this.smartBox2.nativeElement.offsetHeight + 'px';
        } else {
            this.smartHeight2 = '';
            this.smartHeight1 = '';
        }
    }


    // about list

    public textList = [];


}

